// extracted by mini-css-extract-plugin
export default {"answer":"Answer_answer__Fx4h6","question":"Answer_question__VO0qG","audio_container":"Answer_audio_container__t-+bF","bottom_bar":"Answer_bottom_bar__8J18f"};